"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactChartjs = require("react-chartjs-2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//Line Graph Implementation 
function LineGraph(data) {
  const Labels = data.data.map(lan => lan.label);
  const dataVal = data.data.map(val => val.value);
  const graphData = {
    labels: Labels,
    datasets: [{
      label: 'Data',
      data: dataVal,
      borderColor: '#1F70B7'
    }]
  };
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: {
        scaleLabel: {
          display: true
        },
        ticks: {
          beginAtZero: true
        }
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: data.backstyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: data.style
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Line, {
    data: graphData,
    options: graphOptions,
    LineStyle: "#1F70B7"
  })));
}
var _default = exports.default = LineGraph;